import * as React from 'react';
import { AvatarImg } from './Avatar.styles';
import { jsx as _jsx } from "react/jsx-runtime";
function Image({
  src,
  alt,
  handleImageError,
  ...restProps
}) {
  return /*#__PURE__*/_jsx(AvatarImg, {
    src: src,
    alt: alt,
    ...restProps,
    onError: handleImageError
  });
}
export default Image;